import {pixels, QuadrangleVertex, X} from '../../abstract-units';
import {CellAreaDefinition} from '../area-definition';
import {CellAreaType} from '../cell-area-type';
import {EDGE_AREA_THICKNESS_PX} from './common';
import {TOP_EDGE_CELL_AREA_DEF} from './top-edge';

const HEADER_HEIGHT = 24;
const HEADER_AREA_BOTTOM_Y = pixels(EDGE_AREA_THICKNESS_PX + HEADER_HEIGHT);

export const HEADER_CELL_AREA_DEF: CellAreaDefinition = {
    type: CellAreaType.HEADER,
    boxEdge: null,
    vertices: [
        TOP_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_LEFT], // TOP_LEFT
        TOP_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_RIGHT], // TOP_RIGHT
        [
            TOP_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_LEFT][X],
            HEADER_AREA_BOTTOM_Y
        ], // BOTTOM_LEFT
        [
            TOP_EDGE_CELL_AREA_DEF.vertices[QuadrangleVertex.BOTTOM_RIGHT][X],
            HEADER_AREA_BOTTOM_Y
        ] // BOTTOM_RIGHT
    ]
};
